import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useContext, useMemo, useState } from 'react';
// import QrScanner from "react-qr-scanner";
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import TreeViewer from 'global/components/viewers/TreeViewer';
import QrScan from '../pageItemActions/QrScan';

export const _gamificationTypes = {
  appUser: 'appUser',
  item: 'item'
}

const _scanTypes = {
  connections: 'connections',
  items: 'items',
}

export const UiGamification = ({ gamificationType, handleCancel }) => {

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { appUserSessionKey } = appUserSession ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state, eventInfo_state } = states
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appGamification, appNetworking } = aps_global ?? {}
  const { appUserCollection } = aps_appUserSettings ?? {}
  const { allowGamification } = appGamification ?? {}
  const { allowNetworking } = appNetworking ?? {}

  const isMobileDevice = _.get(app_state, 'currentEnvironment.platform.isMobileDevice', false)

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { isMobileDevice: _isMobileDevice } = framework_state ?? {}

  const _topperCaption = useMemo(() => {
    switch (gamificationType) {
      case _gamificationTypes.appUser:
        return 'Scan App User';
      case _gamificationTypes.item:
        return 'Scan Item';
    }
  }, [gamificationType])

  const [scannedData, setScannedData] = useState()

  const handleScan = (_scannedData) => {
    if (_scannedData) {
      try {
        setScannedData(_scannedData)
      } catch (error) {
        setScannedData({ qrKey: 5678 })
      }
    }
  }

  const handleConnections = async () => {
    const { _itemKey } = scannedData
    const promises = []

    const dataToUpdate1 = { [appUserCollection]: { [_itemKey]: true } }
    const _refPath1 = createRefPath_event(pathViews, ['_appUserConnections', appUserSessionKey])
    promises.push(database_fns.set_doc(_refPath1, dataToUpdate1, true))

    const dataToUpdate2 = { [appUserCollection]: { [appUserSessionKey]: true } }
    const _refPath2 = createRefPath_event(pathViews, ['_appUserConnections', _itemKey])
    promises.push(database_fns.set_doc(_refPath2, dataToUpdate2, true))

    return Promise.all(promises)

  }

  const handleInteractions = async () => {
    const { _itemKey, itemType } = scannedData
    const promises = []

    const dataToUpdate1 = { [itemType]: { [_itemKey]: true } }
    const _refPath1 = createRefPath_event(pathViews, ['_appUserInteractions', appUserSessionKey])
    promises.push(database_fns.set_doc(_refPath1, dataToUpdate1, true))

    const dataToUpdate2 = { [appUserCollection]: { [appUserSessionKey]: true } }
    const _refPath2 = createRefPath_event(pathViews, ['_appUserInteractions', _itemKey])
    promises.push(database_fns.set_doc(_refPath2, dataToUpdate2, true))

    return Promise.all(promises)

  }

  const handleUpdate = async () => {
    switch (gamificationType) {
      case _gamificationTypes.appUser:
        await handleConnections()
        handleCancel()
        break;

      case _gamificationTypes.item:
        await handleInteractions()
        handleCancel()
        break;
    }
  }

  const handleClear = () => setScannedData()

  const qrReader = () => {
    const previewStyle = {
      width: "100%",
    };

    return (
      <QrScan handleCancel={handleCancel} handleScannedData={handleScan} />
    )
  };

  const content = () => {
    if (scannedData) {
      return <TreeViewer data={scannedData} />
    } else {
      return qrReader(128)
    }
  }

  const footer = () => {
    if (!scannedData) return;
    const btns = []
    btns.push({ oc: handleUpdate, caption: `Connect ${_.startCase(gamificationType)}`, icon: 'save' })
    btns.push({ oc: handleClear, caption: 'Close', icon: 'delete', fl: true, color: 'grey' })
    return <UiSaveButtons
      others={btns}
      color={'blue'}
    />
  }

  const wrapper = () => <Wrapper
    content={content()}
    footer={scannedData && footer()}
    wrapperType={wrapperTypes.padded}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={_topperCaption}
    wrapperCss={{ container: 'app-dark-mode' }}
  />

  return fullPageWrapper()
}
